// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-loader{margin:0 0 2em;text-align:center;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100%;height:100%;background:#000}.button-loader svg path,.button-loader svg rect{fill:#fff}.button-loader svg{margin:auto;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = exports;
